import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { BASE } from '@client-hub/shared/constants/routes'
import MfaBackup, { MfaBackupContentType } from 'components/Mfa/Backup'
import { useMfaNavigateState, useRedirect } from 'hooks'

const MfaSetupBackup = () => {
  const content: MfaBackupContentType = { showLogo: true }
  const navigate = useNavigate()
  const { from, isAllowedMfa } = useMfaNavigateState()

  useRedirect(!isAllowedMfa)

  const onContinue = useCallback(() => navigate(from?.pathname ? from?.pathname : BASE), [from?.pathname, navigate])

  if (!isAllowedMfa) return null

  return <MfaBackup content={content} onContinue={onContinue} />
}

export default MfaSetupBackup
